import styled from 'styled-components';

export const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
gap: 5px;
width: 100%;
height: auto;
border-bottom: 1px solid #CCCCCC;
padding-bottom: 20px;
background: white;
&:last-child {
    border-bottom: none !important;
    padding-bottom: 0;
}
.accordion {
    box-shadow: none;
    width: 100%;
    padding: 0;
    background: transparent;
}
.accordion-detail {
    width: 100%;
    padding: 0;
    box-shadow: none;
    margin-top: -5px;
}
.label {
    font-size: 16px;
    color: #0D2439;
    font-weight: 500;
    @media (max-width: 600px) {
        font-size: 15px !important;
    }
}
.css-ahj2mt-MuiTypography-root {
    width: 700px !important;
}
.header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;
}
.chip {
    font-size: 13px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    gap: 5px;
    background:#29BCAB1A;
    color:rgb(5, 75, 55);
    border-radius: 20px;
    font-weight: 600px;
    width: auto !important;
    svg {
        width: 14px;
        height: 14px;
        color: rgb(5, 75, 55);
    }
}
.active-filter {
    padding: 12px !important;
    width: 100%;
    background-color: #F4F4F4;
    border: 1px solid #E5E7EB;
    height: 47px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    font-size: 14px;
    svg {
        width: 17px;
        height: 17px;
        cursor: pointer
    }
}
.items {
    width: 100%;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    max-height: 210px;
    overflow: scroll;
    overflow-x: hidden;
    margin-top: 5px;
    .item {
        width: 100% !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 0px;
        margin: auto;
        padding: 3px 0 !important;
        cursor: pointer;
        &:hover {
            background: #29BCAB1A;
            border-radius: 10px;
        }
    }
    .label {
        font-size: 16px;
        font-weight: 400;
        color: #0D2439;
        @media (max-width: 600px) {
            font-size: 15px !important;
        }
    }
    .span {
        border: 1px solid #CCCCCC;
        border-radius: 50%;
        height: 16px;
        width: 16px;
    }
    .tick {
        background:rgba(69, 144, 144, 1);
        border: 1px solid rgba(69, 144, 144, 1);
    }
}
`